import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const RESULTS = [
  { label: "Result 01", before: "/images/before-1.webp", after: "/images/after-1.webp" },
  { label: "Result 02", before: "/images/before-8.webp", after: "/images/after-8.webp" },
  { label: "Result 03", before: "/images/before-9.webp", after: "/images/after-9.webp" },
];

export const Results = () => {
  const [index, setIndex] = useState(0);
  const pair = RESULTS[index];

  return (
    <section className="bg-[#F8F4EC]" data-testid="results-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">Hair Results</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] mb-12">
          The look we're <span className="italic text-[#3A2A25]">going for.</span>
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl mx-auto"
        >
          <div className="rounded-2xl bg-[#EDE3D6] border border-[rgba(58,42,37,0.08)] p-4 sm:p-6" data-testid="results-comparison">
            <AnimatePresence mode="wait">
              <motion.div
                key={pair.label}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.35 }}
                className="grid grid-cols-2 gap-3 sm:gap-5"
              >
                <div className="relative rounded-xl overflow-hidden aspect-[3/4] sm:aspect-[4/5]">
                  <img
                    src={pair.before}
                    alt={`Hair before using CELUSTA — ${pair.label}`}
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                    data-testid="results-before-image"
                  />
                  <span className="absolute bottom-3 left-3 px-4 py-1.5 rounded-full bg-white/85 backdrop-blur border border-[#3A2A25]/30 text-[11px] font-mono-accent uppercase tracking-[0.15em] text-[#3A2A25]">Before</span>
                </div>
                <div className="relative rounded-xl overflow-hidden aspect-[3/4] sm:aspect-[4/5]">
                  <img
                    src={pair.after}
                    alt={`Hair after using CELUSTA — ${pair.label}`}
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                    data-testid="results-after-image"
                  />
                  <span className="absolute bottom-3 left-3 px-4 py-1.5 rounded-full bg-[#3A2A25] text-[11px] font-mono-accent uppercase tracking-[0.15em] text-white">After</span>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-testid="results-pair-selector">
            {RESULTS.map((r, i) => (
              <button
                key={r.label}
                onClick={() => setIndex(i)}
                className={`px-6 py-2.5 rounded-full text-[11px] font-mono-accent uppercase tracking-[0.15em] border transition-colors duration-300 ${
                  i === index
                    ? "bg-[#3A2A25] text-white border-[#3A2A25]"
                    : "bg-transparent text-[#3A2A25] border-[rgba(58,42,37,0.25)] hover:bg-[#EDE3D6]"
                }`}
                data-testid={`results-pair-button-${i}`}
              >
                {r.label}
              </button>
            ))}
          </div>
          <p className="mt-6 text-center text-xs font-light text-[#9A8D85]">Individual results vary.</p>
        </motion.div>
      </div>
    </section>
  );
};
